import type { NDateLocale } from './enUS'
import { be } from 'date-fns/locale'

const dateBeBY: NDateLocale = {
  name: 'be-BY',
  locale: be
}

export default dateBeBY
